import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import UIKIT from 'uikit';
import {useInput} from '../../../hook';
import {
  managerChangeOrderDetailStatusAction,
  managerChangeOrderDetailStatusResetAction,
} from '../../../actions/order/action';

const ReturnModal = ({openReturnModal, setOpenReturnModal, targetOrderDetail}) => {
  const dispatch = useDispatch();

  const {
    updateManagerChangeOrderDetailStatusDone,
    updateManagerChangeOrderDetailStatusError,
    updateManagerChangeOrderDetailStatus,
  } = useSelector(state => state.order);

  const etcFee = useInput(0);

  const onSubmit = useCallback(
    e => {
      e.preventDefault();
      UIKIT.modal('#returnModal').hide();
      setOpenReturnModal(false);
      const formData = new FormData();
      formData.append('status', 3);
      formData.append('isReturnDeliveryFee', 0);
      formData.append('etcFee', etcFee.value);
      formData.append('_method', 'PUT');
      dispatch(managerChangeOrderDetailStatusAction(targetOrderDetail.seq, formData));
    },
    [etcFee],
  );

  useEffect(() => {
    if (openReturnModal && targetOrderDetail) {
      UIKIT.modal('#returnModal').show();
      setOpenReturnModal(false);
    }
  }, [openReturnModal, targetOrderDetail]);

  useEffect(() => {
    if (updateManagerChangeOrderDetailStatusDone) {
      alert(updateManagerChangeOrderDetailStatus.msg);
      window.location.reload();
    }

    if (updateManagerChangeOrderDetailStatusError) {
      alert(updateManagerChangeOrderDetailStatusError.msg);
      dispatch(managerChangeOrderDetailStatusResetAction());
    }
  }, [updateManagerChangeOrderDetailStatusDone, updateManagerChangeOrderDetailStatusError]);

  return (
    <div id="returnModal" className="uk-position-z-index-9999999" data-uk-modal="container:false;">
      <div className="uk-modal-dialog">
        <button className="uk-modal-close-default" type="button" data-uk-close></button>
        <div className="uk-modal-header uk-padding-small-horizontal uk-padding-horizontal@m">
          상품 상세 주문번호: {targetOrderDetail && targetOrderDetail.seq} 반품 정보 확인
        </div>
        <div className="uk-modal-body uk-padding-remove-horizontal uk-padding-horizontal@m">
          <div className="uk-text-0_9 uk-grid-divider" data-uk-grid>
            <div className="uk-width-1-1 uk-width-1-1@m">
              <form onSubmit={onSubmit}>
                <div className="uk-margin">
                  <div className="uk-background-muted uk-padding-small">
                    <h5 className="uk-text-bold uk-margin-small-bottom">반품 비용 결제방법</h5>
                    <div className="uk-margin-small">
                      <span className="uk-text-primary uk-text-bold">
                        {targetOrderDetail?.returnInfo?.claimDeliveryFeePayMethod}
                      </span>
                    </div>
                    {['판매자에게 직접 송금', '판매자에게 직접 송금하거나 상품에 동봉'].includes(
                      targetOrderDetail?.returnInfo?.claimDeliveryFeePayMethod,
                    ) && (
                      <div className="uk-text-danger uk-text-small uk-margin-small-top">
                        * 반품비용 입금 확인 후 처리를 진행해주세요.
                      </div>
                    )}
                    {['지금결제-추가결제', '환불금에서 차감', '지금 결제함-추가결제', '환불금 차감'].includes(
                      targetOrderDetail?.returnInfo?.claimDeliveryFeePayMethod,
                    ) && (
                      <div className="uk-text-success uk-text-small uk-margin-small-top">
                        * 자동으로 환불금에서 차감되어 처리됩니다.
                      </div>
                    )}
                    {![
                      '판매자에게 직접 송금',
                      '판매자에게 직접 송금하거나 상품에 동봉',
                      '지금결제-추가결제',
                      '환불금에서 차감',
                      '지금 결제함-추가결제',
                      '환불금 차감',
                    ].includes(targetOrderDetail?.returnInfo?.claimDeliveryFeePayMethod) && (
                      <div className="uk-text-muted uk-text-small uk-margin-small-top">
                        * 해당 결제 방식에 대한 별도의 안내 내용이 없습니다. 관리자에게 문의해주세요.
                      </div>
                    )}
                  </div>
                </div>
                <div className="uk-margin">
                  <label className="uk-form-label" htmlFor="etcFee">
                    기타청구금액
                  </label>
                  <div className="uk-form-controls">
                    <div className="uk-inline uk-width-1-1">
                      <span className="uk-form-icon uk-form-icon-flip" style={{fontSize: '0.9rem'}}>
                        원
                      </span>
                      <input
                        className="uk-input uk-text-right"
                        name="etcFee"
                        id="etcFee"
                        type="text"
                        placeholder="0"
                        value={etcFee.value.toLocaleString()}
                        onChange={event => etcFee.onChange(event, 1)}
                      />
                    </div>
                  </div>
                </div>
                <div className="uk-margin-medium-top uk-text-right">
                  <button className="uk-button uk-button-default uk-modal-close uk-margin-small-right" type="button">
                    취소
                  </button>
                  <button className="uk-button uk-button-primary" type="submit">
                    반품확인 처리
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnModal;
